<template>
  <div class="useLayout">
    <!-- 搜索框区域 -->
    <div class="search-wrapper" v-if="searchList.length > 0">
      <el-form ref="useForm" :inline="true" :model="formData" class="demo-form-inline search-grid-form" label-width="70px">
        <el-form-item v-for="(item, index) in visibleSearchList" :key="index" :label="item.name">
          <!-- 输入框 -->
          <div class="text" v-if="item.type == 'text'">
            <el-input v-model.trim="formData[item.key]" :placeholder="item.placeholder" />
          </div>
          <!-- 时间选择器 -->
          <div class="dateTime" v-if="item.type == 'dateTime'">
            <el-date-picker v-model="formData[item.key]" type="daterange" unlink-panels range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
              placeholder="请选择日期" :shortcuts="shortcuts" :disabledDate="disabledDateFn" :clearable="account_type == 1 || account_type == 6 || account_type == 2" />
          </div>
          <!-- 下拉框 -->
          <div class="select" v-if="item.type == 'select'">
            <el-select v-model="formData[item.key]" filterable :clearable="item.clearable || true" placeholder="请选择">
              <el-option v-for="(ele, eleIndex) in item.data" :key="eleIndex" :label="item.codeLabel != undefined ? ele[item.codeLabel] : ele.label
                " :value="item.codeValue != undefined ? ele[item.codeValue] : ele.value
      " />
            </el-select>
          </div>
        </el-form-item>
        <!-- 按钮区域：跟在条件后面 -->
        <el-form-item class="form-action-item" :class="{ 'has-collapse': hasMoreSearchItems }">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button v-if="hasMoreSearchItems" link type="primary" class="toggle-btn" @click="toggleSearch">
            {{ showAllSearch ? '收起更多' : '展开更多' }}
            <svg class="toggle-icon" :class="{ 'is-open': showAllSearch }" viewBox="0 0 1024 1024" width="12" height="12" fill="currentColor"><path d="M512 714.667c-8.533 0-17.067-2.134-23.467-8.534L147.2 364.8c-12.8-12.8-12.8-34.133 0-46.933s34.133-12.8 46.933 0L512 635.733l317.867-317.866c12.8-12.8 34.133-12.8 46.933 0s12.8 34.133 0 46.933L535.467 706.133c-6.4 6.4-14.934 8.534-23.467 8.534z"/></svg>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增等批量操作 -->
    <div class="button-list" v-if="props.buttonList.length > 0 && props.buttonVisible && MONEYPOWERID != 7">
      <el-button v-for="(item, index) in props.buttonList" :key="index" :type="item.buttonType" v-show="setShow(item)"
        @click="handleClick(item.type)">{{ item.title }}</el-button>
    </div>
    <!-- 表格 -->
    <el-table ref="useTable" id="useTable" :data="tableData" style="width: 100%" v-loading="loading"
      :max-height="maxHeight" :row-class-name="tableRowClassName" class="table">
      <el-table-column v-for="(item, index) in props.tableHeader" :key="index" :prop="item.prop" :label="item.label"
        :width="item.width" :fixed="item.fixed" align="center">
        <template #default="scope">
          <div v-if="item.hasOwnProperty('slot')">
            <slot :name="item.slot" :scope="scope"></slot>
          </div>
          <!-- 付款金额 -->
          <div class="config" v-if="item.prop == 'remit_money'">
            <span class="green-text bold-text">{{
              scope.row.remit_money
            }}</span>
          </div>
          <!-- 总金额 -->
          <div class="config" v-if="item.prop == 'money'">
            <span class="bold-text">{{ scope.row.money }}</span>
          </div>
          <!-- 欠款金额 -->
          <div class="config" v-if="item.prop == 'arrears_money'">
            <span class="orange-text bold-text">{{
              scope.row.arrears_money
            }}</span>
          </div>
          <!-- 退款金额 -->
          <div class="config" v-if="item.prop == 'back_money'">
            <span class="red-text bold-text">{{ scope.row.back_money }}</span>
          </div>
          <!-- 操作列 -->
          <div class="config" v-if="item.prop == 'config'">
            <slot name="config" :scope="scope"></slot>
          </div>
          <!-- 合同 -->
          <div class="config" v-if="item.prop == 'offline_agreement'">
            <slot name="offline_agreement" :scope="scope"></slot>
          </div>
          <!-- 账号等级 -->
          <div class="account_type" v-if="item.prop == 'account_type'">
            <slot name="account_type" :scope="scope"></slot>
          </div>
          <!-- 默认 -->
          <span v-if="!scopeArr.includes(item.prop)">{{
            scope.row[item.prop]
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="footer">
      <div class="countNum" v-if="MONEYISPOWER && props.is_refund">
        已退款金额：<span class="bold-text red-text">{{
          handlerMark(refund_money)
        }}</span>
        元
      </div>
      <div class="countNum" v-if="MONEYISPOWER && props.is_count">
        付款总金额：<span class="bold-text green-text">{{
          handlerMark(count_money)
        }}</span>
        元
      </div>
      <div class="countNum" v-if="MONEYISPOWER && props.is_arrears">
        欠款总金额：<span class="bold-text orange-text">{{
          handlerMark(debt_money)
        }}</span>
        元
      </div>
      <div class="countNum" v-if="MONEYPOWERID == 1 && props.isSale">
        今天加总V：<span class="bold-text orange-text">{{ countData.dt_v }}</span>，
        昨天加总V：<span class="bold-text orange-text">{{ countData.zt_v }}</span>，
        前天加总V：<span class="bold-text orange-text">{{ countData.qt_v }}</span>，
        大前天加总V：<span class="bold-text orange-text">{{ countData.dqt_v }}</span>
      </div>
      <el-pagination background :page-sizes="[10, 20, 30, 50, 100]" :default-page-size="defaultSize"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper" :total="total" />
    </div>
  </div>
</template>
<script setup>
import { shortcuts, disabledDateFn, monthTime } from "@/api/date-time";
// import { apiPost } from '@/plugins/axiosInstance';
import { MONEYPOWER, handlerMark } from "@/api/common";
import { apiPost } from '@/plugins/axiosInstance';
import {
  defineProps,
  defineEmits,
  defineExpose,
  onMounted,
  ref,
  reactive,
  computed,
  nextTick,
  watch,
} from "vue";
const props = defineProps({
  tableHeader: {
    default: [],
  },
  defaultSize: {
    default: 10
  },
  tableUrl: {
    default: "",
  },
  extraFormData: {
    default: {}
  },
  searchList: {
    default: [],
  },
  debt_money: {
    default: 0,
  },
  refund_money: {
    default: 0,
  },
  buttonList: {
    default: [],
  },
  buttonVisible: {
    default: true,
  },
  is_count: {
    default: false,
  },
  is_refund: {
    default: false,
  },
  is_arrears: {
    default: false,
  },
  isSale: {
    default: false
  }
});
const MONEYPOWERID = sessionStorage.getItem("account_type");
const MONEYISPOWER = MONEYPOWER.includes(MONEYPOWERID);
const emits = defineEmits(["handleClick"]);

const scopeArr = reactive([
  "config",
  "account_type",
  "back_money",
  "remit_money",
  "arrears_money",
  "money",
  "offline_agreement"
]);

const account_type = ref(sessionStorage.getItem("account_type"));

// 搜索框折叠配置
const showAllSearch = ref(true);
const ROW_COLS = 5;          // 每行 5 个
const COLLAPSE_THRESHOLD = 15; // 超过 15 个才启用折叠功能
const COLLAPSE_KEEP = 5;     // 折叠后只保留前 1 行（5 个）

// 按权限过滤后的搜索条件
const filteredSearchList = computed(() => {
  return props.searchList.filter(item => item.power && item.power.includes(account_type.value));
});

// 当前实际渲染的搜索条件
const visibleSearchList = computed(() => {
  if (showAllSearch.value) {
    return filteredSearchList.value;
  }
  return filteredSearchList.value.slice(0, COLLAPSE_KEEP);
});

// 是否启用折叠（条件 > 15 个才需要折叠）
const hasMoreSearchItems = computed(() => {
  return filteredSearchList.value.length >= COLLAPSE_THRESHOLD;
});

const handleSearch = () => {
  page.value = 1;
  getTableData();
};

const handleReset = () => {
  initFormData();
  page.value = 1;
  getTableData();
};

const toggleSearch = () => {
  showAllSearch.value = !showAllSearch.value;
};

// 展开/收起时重新计算表格高度
watch(showAllSearch, () => {
  nextTick(() => {
    let useTable = document.getElementById('useTable');
    if (useTable) {
      maxHeight.value = window.innerHeight - useTable.offsetTop - 70;
    }
  });
});

let loading = ref(true);
const handleSizeChange = (index) => {
  size.value = index;
  getTableData();

};

const handleCurrentChange = (index) => {
  page.value = index;
  getTableData();
};
// const formData = computed(() => {
//     let data = {}
//     props.searchList.forEach(ele => {
//         data[ele.key] = '';
//     })
//     return data
// });
const formData = reactive({});

const setShow = (item) => {
  if (item.type == 'export') {
    if (MONEYPOWERID == 1|| MONEYPOWERID == 61) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}
// const search = async () => {
//   await emits("search", formData)
//   loading.value = false;
// };

const handleClick = (type) => {
  emits("handleClick", type);
};


const initFormData = () => {
  let obj = {};
  props.searchList.forEach(ele => {
    if (ele.type == 'text' || ele.type == 'select') {
      obj[ele.key] = "";
    } else if (ele.type == 'dateTime') {

      if (ele.default == 'month') {
        obj[ele.key] = monthTime();
      }
    }
  })
  return Object.assign(formData, obj);
}
// 获取数据
let page = ref(1);
let size = ref(10);
let total = ref(0);
let tableData = reactive([]);
let count_money = ref(0);
let refund_money = ref(0);
let debt_money = ref(0);
let countData = ref({});
const getTableData = async () => {
  // if (type == 'search') {
  //   page.value = '1';
  // }
  let newData = JSON.parse(JSON.stringify(formData))
  props.searchList.forEach(ele => {
    if (ele.type == 'dateTime' && newData[ele.key] != undefined && newData[ele.key].length > 0 && Array.isArray(newData[ele.key])) {
      newData[ele.key] = newData[ele.key].join(',')
      
    }
  })
  loading.value = true;

  await apiPost(props.tableUrl, {
    ...newData,
    ...props.extraFormData,
    page: page.value,
    limit: size.value || 10
  }).then(res => {
    loading.value = false;
    tableData.length = 0;
    count_money.value = res.data.count_money;
    refund_money.value = res.data.refund_money;
    debt_money.value = res.data.debt_money;
    Object.assign(tableData, res.data.list);
    page.value = res.data.page;
    size.value = res.data.limit;
    total.value = res.data.total;
    countData.value = {
      dt_v: res.data.dt_v,
      zt_v: res.data.zt_v,
      qt_v: res.data.qt_v,
      dqt_v: res.data.dqt_v,
    }
  })
}

let maxHeight = ref("640")



onMounted(async () => {
  initFormData();
  await selectDataList();
  await getTableData();
  nextTick(() => {
    // let aa = useTable.value
    let useTable = document.getElementById('useTable');
    maxHeight.value = window.innerHeight - useTable.offsetTop - 70;
  })
});
defineExpose({
  formData,
  getTableData,
  total,
});



// 颜色
const tableRowClassName = ({ row }) => {
  if (row.whether == '1') {
    return 'success-row'
  }
}

// 
const selectDataList = async () => {
  let arr = props.searchList.filter((ele) => ele.type == 'select')
  arr.forEach(async ele => {
    if (ele.value != undefined) {
      formData[ele.key] = ele.value;
    }
    if (ele.url != undefined) {
      await apiPost(ele.url, ele.urlData).then(res => {
        if (ele.screen != undefined && ele.screen) {
          ele.data.length = 1;
          ele.data.push(...res.data.filter(item => !item.label.includes('离职') && !item.label.includes('作废') && !item.label.includes('销售账号')));
        } else {
          ele.data = res.data;
        }
      })
    }

  })
}
onMounted(() => {
  console.log('执行')
  size.value = props.defaultSize;
})
</script>
  
<style lang="scss" scoped>
// 搜索框区域
.search-wrapper {
  padding: 16px 20px 0;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}

// 搜索表单：保持 inline 横向布局，用 Grid 控制每行 5 个 form-item
.search-grid-form {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0 16px;
  margin-bottom: 12px;

  ::v-deep(.el-form-item) {
    margin-right: 0;
    margin-bottom: 12px;
  }

  // 按钮项：不占满 1fr，按内容宽度显示，跟在条件后面
  ::v-deep(.form-action-item) {
    width: auto;
    grid-column: auto;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    border: none;

    .el-form-item__content {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    // 启用折叠时，按钮组靠右对齐：让这格跨到最后一列
    &.has-collapse {
      grid-column: 5;
      justify-self: end;
    }
  }
}

.toggle-btn {
  font-size: 13px;

  .toggle-icon {
    margin-left: 4px;
    transition: transform 0.25s ease;
    // 默认向下箭头 ▼，表示"点我展开更多"
    transform: rotate(0deg);

    // 展开后旋转向上 ▲，表示"点我收起"
    &.is-open {
      transform: rotate(180deg);
    }
  }
}

.footer {
  margin: 20px;

  .el-pagination {
    float: right;
  }

  .countNum {
    float: left;
  }
}

.button-list {
  margin: 0px 20px;
  margin-bottom: 10px;
}

.table ::v-deep(.el-scrollbar__bar, .is-horizontal) {
  height: 12px !important;
}

::v-deep(.el-table .success-row) {
  --el-table-tr-bg-color: #ecf4ff;
}

::v-deep(.el-scrollbar__bar) {
  display: block !important;
}

::v-deep(.el-scrollbar__thumb) {
  opacity: 0.6;
}

@media (max-width: 767px) {
  .search-grid-form {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>